import { useEffect, useRef, useState } from "react";

export const AI_CHAT_DEFAULT_WIDTH = 360;
export const AI_CHAT_DEFAULT_HEIGHT = 465;
const AI_CHAT_MIN_WIDTH = 280
const AI_CHAT_MIN_HEIGHT = 380

const useAiChatPopoverResize = () => {
  const [hasMoved, setHasMoved] = useState(false)
  const frame = useRef<number | null>(null);
  const resizing = useRef(false);
  const startPos = useRef({ x: 0, y: 0, width: 0, height: 0 });
  const popoverRef = useRef<HTMLDivElement | null>(null);

  const onResizeStart = (e: React.MouseEvent) => {

    e.preventDefault();
    e.stopPropagation();
    resizing.current = true;

    const el = popoverRef.current;
    if (!el) return;

    startPos.current = {
      x: e.clientX,
      y: e.clientY,
      width: el.offsetWidth,
      height: el.offsetHeight,
    };
  };

  const onResizing = (e: MouseEvent) => {
    if (!resizing.current) return;

    const dx = e.clientX - startPos.current.x;
    const dy = e.clientY - startPos.current.y;

    let newWidth = Math.max(AI_CHAT_MIN_WIDTH, startPos.current.width - dx);
    let newHeight = Math.max(AI_CHAT_MIN_HEIGHT, startPos.current.height - dy);

    if (frame.current) cancelAnimationFrame(frame.current);

    frame.current = requestAnimationFrame(() => {
      const el = popoverRef.current;
      if (!el) return;
      el.style.width = `${newWidth}px`;
      el.style.height = `${newHeight}px`;
      setHasMoved(true);
    });
  };

  const onResizeEnd = () => {
    resizing.current = false;
    if (frame.current) cancelAnimationFrame(frame.current);
  };

  const resetSizeToDefault = () => {
    const el = popoverRef.current;
    if (el) {
      el.style.width = `${AI_CHAT_DEFAULT_WIDTH}px`;
      el.style.height = `${AI_CHAT_DEFAULT_HEIGHT}px`;
    }
    setHasMoved(false)
  }

  useEffect(() => {
    window.addEventListener('mousemove', onResizing);
    window.addEventListener('mouseup', onResizeEnd);
    return () => {
      window.removeEventListener('mousemove', onResizing);
      window.removeEventListener('mouseup', onResizeEnd);
    };
  }, []);
  return {
    popoverRef,
    hasMoved,
    resetSizeToDefault,
    onResizeStart
  }
}

export default useAiChatPopoverResize;